import React from 'react';
import {type UseFormReturn} from 'react-hook-form';
import {type IAttributeTemplate} from '../../schema';
import {
	ReactHookFormEditableAttribute,
	type ReactHookFormEditableAttributeProps,
} from '../EditableAttribute/ReactHookFormEditableAttribute';
import {
	ReadOnlyAttribute,
	type ReadOnlyAttributeProps,
} from '../ReadOnlyAttribute';

type CommonProps = {
	attrData: IAttributeTemplate;
	control: UseFormReturn['control'];
	readOnly?: boolean;
};

export type AttributeProps = CommonProps &
	Omit<ReadOnlyAttributeProps, 'attrData'> &
	Omit<ReactHookFormEditableAttributeProps, 'attrData' | 'control'>;

export const Attribute = ({
	attrData,
	control,
	readOnly,
	...props
}: AttributeProps) => {
	if (
		readOnly ||
		attrData.permission === 'r' ||
		// TODO: we did something wrong in our attributes collection and system attributes that
		// are editable have a boolean ¯\_(ツ)_/¯
		attrData.permission === (false as any)
	)
		return (
			<ReadOnlyAttribute control={control} {...props} attrData={attrData} />
		);
	return (
		<ReactHookFormEditableAttribute
			{...props}
			control={control}
			attrData={attrData}
		/>
	);
};

export default Attribute;
